<div style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Colaboradores </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <div>
        <select
          class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
          aria-label=".form-select-lg"
          [formControl]="ordenarControl"
        >
          <option disabled>Ordenar</option>
          <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
        </select>
      </div>
      <div *ngIf="!empresaDaSessao">
        <select
          class="w-60 form-select form-select-lg text-white font-medium bg-blumine"
          aria-label="Filtrar por empresa"
          [formControl]="companyControl"
        >
          <option [ngValue]="null">Todas empresas</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>
      </div>
      <div>
        <select
          class="w-48 form-select form-select-lg text-white font-medium bg-blumine"
          aria-label="Filtrar por situação"
          [formControl]="statusControl"
        >
          <option [ngValue]="null">Todas as situações</option>
          <option *ngFor="let status of opcoesStatus" [ngValue]="status.value">{{ status.label }}</option>
        </select>
      </div>
      <!-- OE-1808: form de busca para o Enter e o "Ir" do teclado do celular pesquisarem sem recarregar a página. -->
      <form class="contents" role="search" aria-label="Pesquisar colaboradores" (ngSubmit)="filtrarColaborador()">
        <div>
          <input
            [formControl]="acaoInput"
            type="search"
            class="form-input w-72"
            placeholder="Nome, CPF, matrícula ou e-mail"
            title="Pesquise por nome, CPF, matrícula ou e-mail"
            aria-label="Pesquise por nome, CPF, matrícula ou e-mail"
          />
        </div>
        <div class="flex justify-between">
          <button type="submit" title="Filtrar Colaborador" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
            <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
          </button>
          <button
            type="button"
            title="Limpar Filtros"
            (click)="limparFiltros()"
            class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
          >
            <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
          </button>
          <button
            *isAllowed="[ERoleAdminString.Admin, 'employee.export']"
            type="button"
            title="Download Excel com Colaboradores"
            class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
            (click)="downloadExcel()"
          >
            <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
          </button>
        </div>
      </form>
    </div>
  </div>

  <p *ngIf="termoBuscado" data-testid="resumo-busca" class="mt-6 text-chathams-blue" aria-live="polite">
    {{ dadosPaginacao.itensTotal }} {{ dadosPaginacao.itensTotal === 1 ? 'resultado' : 'resultados' }} para "{{
      termoBuscado
    }}"
    <button type="button" class="ml-2 font-semibold underline" (click)="limparBusca()">Limpar busca</button>
  </p>

  <div class="inline-block w-full mt-8">
    <app-list-employees
      [employers]="employers"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="carregarColaborador()"
    ></app-list-employees>
  </div>

  <app-register-employee (recarregarListagem)="carregarColaborador()"></app-register-employee>

  <hr class="my-8" />
</div>
